var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroCardIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E3CEEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2201 37.2198L21.7801 20.7798M42.9601 41.9598L45.8001 44.7998M17.0401 16.0398L14.2001 13.1998M27.3151 10.5068L29.6841 12.8758L13.8661 28.6938L11.4961 26.3248L27.3151 10.5068ZM46.1351 29.3088L48.5041 31.6778L32.6861 47.4958L30.3161 45.1258L46.1351 29.3088ZM22.1011 10.9638L24.4711 13.3318L14.3221 23.4798L11.9531 21.1118L22.1011 10.9638ZM45.6701 34.5148L48.0381 36.8838L37.8901 47.0298L35.5211 44.6608L45.6701 34.5148Z",
    stroke: "#710B95",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCardIcon1);
export default __webpack_public_path__ + "static/media/HeroCardIcon1.b89ee19c5ac62edf0ac37c3ae7bef009.svg";
export { ForwardRef as ReactComponent };